module.exports = __webpack_public_path__ + "img/pollola_sisalta.ae35ea36.jpg";